import {supplierActivitySummaryReportEndpoints} from "../api-endpoints";
import moment from "moment";
import {DateFormats} from "../../components/constants/securspace-constants";

export interface SupplierActivitySummaryRequestParams {
  accountId?: string;
  locationId?: string;
  date: string;
}

/**
 * Builds URL query parameters for supplier activity summary report download.
 * @param requestParams - Parameters for the report request
 * @returns URLSearchParams object with formatted query parameters
 */
const getSupplierActivitySummaryUrlParams = (requestParams: SupplierActivitySummaryRequestParams) => {
  const {
    accountId,
    locationId,
    date
  } = requestParams;

  const params = new URLSearchParams();

  if (accountId) {
    params.append("accountId", accountId);
  }
  if (locationId) {
    params.append("locationId", locationId);
  }
  if (date) {
    params.append("date", moment(date).format(DateFormats.DAY));
  }

  return params;
}

/**
 * Generates the URL for downloading supplier activity summary report as CSV.
 * @param searchParams - Request parameters including optional accountId and locationId, and required date
 * @returns Complete URL string for CSV download endpoint
 */
export const getSupplierActivitySummaryDownload = (searchParams: SupplierActivitySummaryRequestParams) => {
  return `${supplierActivitySummaryReportEndpoints.download}?${getSupplierActivitySummaryUrlParams(searchParams).toString()}`;
};

